import React, { useState, useEffect } from "react"
import { Apirequests } from "../../utils/ApiRequests"
import { ErrorTost, SuccessTost } from "../../utils/ToastHelper"
import BtnSpinner from "../../components/BtnSpinner"

const CreateOrder = ({ close, setRefresh }) => {
    const token = localStorage.getItem("token")

    const [users, setUsers] = useState([])
    const [courses, setCourses] = useState([])
    const [classes, setClasses] = useState([]);
    const [loading, setLoading] = useState({ state: false, name: "" });


    const [formData, setFormData] = useState({
        purchase_type: "",
        paymentMethod: "",
        order_id: "",
        user_id: "",
        amount: "",
        product_id: "",
        status: "",
        notes: { currency: "" },
    })

    const getCourses = async () => {
        try {
            const courseRes = await Apirequests(
                "courses/get-courses",
                "GET",
                {},
                {
                    Authorization: `Bearer ${token}`,
                },
            )

            if (courseRes?.success) {
                setCourses(courseRes?.data)
            }
        } catch (error) {
            console.log("getcourseerror:orderpage", error)
        }
    }

    const getClasses = async () => {
        try {
            const response = await Apirequests(
                "classes/get-classes",
                "GET",
                {},
                {
                    Authorization: `Bearer ${token}`,
                },
            )
            if (response.success) {
                setClasses(response?.data)
            }
        } catch (error) {
            console.log(error, "fetch course error")
        }
    }

    const fetchAllusers = async () => {
        try {
            const res = await Apirequests(
                "users/get-users",
                "GET",
                {},
                {
                    Authorization: `Bearer ${token}`,
                },
            )
            if (res?.success) {
                setUsers(res.data)
            }
        } catch (error) {
            console.log(error, "users res")
        }
    }

    useEffect(() => {
        fetchAllusers()
    }, [])

    useEffect(() => {
        if (formData.purchase_type === "course") {
            getCourses()
        } else if (formData.purchase_type === "classes") {
            getClasses()
        }
    }, [formData.purchase_type])


    useEffect(() => {
        let selectedProduct

        if (formData.product_id && formData?.purchase_type) {
            if (formData?.purchase_type === "course") {
                selectedProduct = courses.find((c) => c._id === formData.product_id)
            } else {
                selectedProduct = classes.find((c) => c._id === formData.product_id)
            }

            if (selectedProduct) {
                setFormData((prev) => ({
                    ...prev,
                    amount: selectedProduct.course_price?.toString() || selectedProduct.class_price?.toString(),
                }))
            }
        }
    }, [formData.product_id, courses, classes])

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData((prev) => ({ ...prev, [name]: value }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading({state:true,name:'addorder'})
        if (!formData.purchase_type || !formData.paymentMethod || !formData.order_id || !formData.user_id || !formData.product_id || !formData.status) return ErrorTost("all of the fields are required.");
        console.log(formData, 'formdata')
        if (formData?.amount === 0) {
            // await onClick({ ...formData, amount: "NA" });
            const addorder = await Apirequests("orders/admin/create-order", "POST", {
                ...formData,
                amount: "NA"
            }, { Authorization: `Bearer ${token}` });
            console.log(addorder, 'addorder')
            if (addorder.success) {
                SuccessTost(addorder.message);
                setRefresh((prev) => !prev);
                setFormData({
                    purchase_type: "",
                    paymentMethod: "",
                    order_id: "",
                    user_id: "",
                    amount: "",
                    product_id: "",
                    status: "",
                    notes:{currency:""}
                })
                close();
            } else {
                ErrorTost(addorder?.message)
            }
        } else {
            const addorder = await Apirequests("orders/admin/create-order", "POST", formData, { Authorization: `Bearer ${token}` });
            console.log(addorder, 'addorder else')
            if (addorder.success) {
                SuccessTost(addorder.message);
                setRefresh((prev) => !prev);
                setFormData({
                    purchase_type: "",
                    paymentMethod: "",
                    order_id: "",
                    user_id: "",
                    amount: "",
                    product_id: "",
                    status: "",
                    notes:{currency:""}
                })

                close();

            } else {
                ErrorTost(addorder?.message)
            }
        }

        setLoading({state:false,name:""})

    }

    //   console.log(classes,'classes')

    return (
        <div className="container mx-auto px-4 py-4">
            <h1 className="text-3xl font-bold mb-6">Add Order</h1>
            <form onSubmit={handleSubmit} className="bg-white rounded px-4 pt-6 pb-8 mb-4">
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="purchase_type">
                        Purchase Type
                    </label>
                    <select
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="purchase_type"
                        name="purchase_type"
                        value={formData.purchase_type}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select Purchase Type</option>
                        <option value="course">Course</option>
                        <option value="classes">Classes</option>
                        <option value="events">Events</option>
                        <option value="others">Others</option>
                    </select>
                </div>

                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="paymentMethod">
                        Payment Method
                    </label>
                    <select
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="paymentMethod"
                        name="paymentMethod"
                        value={formData.paymentMethod}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select Payment Method</option>
                        <option value="card">Card</option>
                        <option value="upi">UPI</option>
                        <option value="admin">Admin</option>
                        <option value="others">Others</option>
                    </select>
                </div>

                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="order_id">
                        Order ID
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="order_id"
                        type="text"
                        placeholder="Order ID"
                        name="order_id"
                        value={formData.order_id}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="user_id">
                        User
                    </label>
                    <select
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="user_id"
                        name="user_id"
                        value={formData.user_id}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select User</option>
                        {users.map((user) => (
                            <option key={user._id} value={user._id}>
                                {user.email}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="product_id">
                        Product
                    </label>
                    <select
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="product_id"
                        name="product_id"
                        value={formData.product_id}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select Product</option>
                        {formData?.purchase_type === "course" ? courses.map((course) => (
                            <option key={course._id} value={course._id} disabled={course?.course_status !== "Active"}>
                                {course?.course_title}
                            </option>
                        )) : classes?.map((cl) =>
                            <option key={cl._id} value={cl._id} disabled={cl?.status !== "Active"}>
                                {cl?.class_title}
                            </option>
                        )}
                    </select>
                </div>

                <div className="mb-6">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="currency">
                        Currency
                    </label>
                    <select
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="currency"
                        name="currency"
                        value={formData.notes.currency}
                        onChange={(e) => setFormData({ ...formData, notes: { currency: e.target.value } })}
                    >
                        <option value="">Select Currency</option>
                        <option value="INR">INR</option>
                        <option value="USD">USD</option>
                    </select>
                </div>

                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="amount">
                        Amount
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="amount"
                        type="number"
                        placeholder="Amount"
                        name="amount"
                        value={formData.amount}
                        onChange={handleChange}
                        required
                        readOnly
                    />
                </div>

                <div className="mb-6">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="status">
                        Status
                    </label>
                    <select
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="status"
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select Status</option>
                        <option value="failed">Failed</option>
                        <option value="captured">Captured</option>
                    </select>
                </div>

                <div className="flex items-center justify-between">
                    <button
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="submit"
                    >
                        {
                            loading?.state && loading.name==="addorder"?
                            <BtnSpinner/>:
                            "Add Order"
                        }
                    </button>
                </div>
            </form>
        </div>
    )
}

export default CreateOrder

